@if (isNew()) {
    <div class="sidebar-menu-item__tag-container">
        <div class="sidebar-menu-item__tag-wrapper">
            <eb-new-tag />
        </div>
    </div>
}
<div class="sidebar-menu-item__row">
    @if (icon) {
        <div class="sidebar-menu-item__icon">
            <eb-icon [icon]="icon" />
            @if ((notifications || 0) > 0) {
                <eb-badge
                    class="sidebar-menu-item__icon-badge"
                    [count]="notifications || 0"
                />
            }
        </div>
    }
    <div class="sidebar-menu-item__label-group">
        <eb-label
            class="sidebar-menu-item__label"
            size="lg"
        >
            {{ label() }}
        </eb-label>
        @if (hasChildren) {
            <eb-icon
                class="sidebar-menu-item__chevron"
                [class.sidebar-menu-item__chevron--open]="submenuOpen()"
                icon="ui/arrow/simple/down"
            />
        }
    </div>
</div>
@if (expanded && !icon) {
    <eb-label
        class="sidebar-menu-item__description"
        size="sm"
    >
        {{ description() }}
    </eb-label>
}
@if (expanded && hasChildren && submenuOpen()) {
    <div class="sidebar-menu-item__submenu">
        @for (child of children(); track child.key) {
            <div
                ebTooltip
                [attr.data-testid]="'sidebar-child-' + child.key"
                tabindex="0"
                role="button"
                class="sidebar-menu-item__child"
                [attr.data-key]="child.key"
                [class.sidebar-menu-item__child--active]="activeChildKey() === child.key"
                [class.sidebar-menu-item__child--locked]="child.locked"
                [display]="!!child.locked && !!child.lockedTooltip"
                [ebTooltipTemplate]="lockedTooltipTemplate"
                [ebTooltipTemplateContext]="{ label: child.lockedTooltip }"
                (click)="onChildClick($event, child)"
                (keyup.enter)="onChildClick($event, child)"
            >
                <eb-label size="lg">
                    {{ child.label }}
                </eb-label>
                @if (child.locked) {
                    <eb-icon
                        class="sidebar-menu-item__lock-icon"
                        icon="ui/common/lock-closed"
                    />
                }
            </div>
        }
    </div>
}

<ng-template
    #lockedTooltipTemplate
    let-label="label"
>
    <div class="sidebar-menu-item__tooltip">
        {{ label }}
    </div>
</ng-template>
